import React from 'react';
import { Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { humanFileSize } from '../../../components/utils/format';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getUserFile } from '../../../store/current-user/CurrentUserActions';
import { deleteServiceTypeFile } from '../../../store/services-manager/ServicesManagerActions';
import { deleteServiceRequestFile } from '../../../store/service-request-manager/ServiceRequestManagerActions';

class FilesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      files: [],
      filesToShow: this.props.filesABC
    };
  }

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
    this.onCancel();
  }

  onDrop(files) {
    if (this.state.files.length === 0) {
      const filesToAdd = _.difference(files, this.state.files);
      this.setState({
        files: this.state.files.concat(filesToAdd),
      });
    }
  }

  onStartUpload() {
    this.props.onFileSubmit(this.state.files);
    this.setState({ showModal: false });
    const filesToAdd = _.difference(this.state.filesToShow, this.state.files);
    this.setState({
      filesToShow: this.state.files.concat(filesToAdd),
    });
  }

  onCancel() {
    this.setState({
      files: [],
    });
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter(
        (file) => file.name !== fileName,
      ),
    });
  }

  deleteFile(fileId, fileName) {
    if (fileId === undefined) {
      if (this.state.files.length > 0) {
        this.setState({
          files: this.state.files.filter(
            (file) => file.name !== fileName,
          ),
        });
      }
      this.setState({
        filesToShow: this.state.filesToShow.filter(
          (file) => file.name !== fileName,
        ),
      });
      toast.success('File has been deleted.');
    }
    else {
      this.setState({
        filesToShow: this.state.filesToShow.filter(
          (file) => file.fileName !== fileName,
        ),
      });
      if (this.props.serviceTypeId !== undefined) {
        this.props
          .deleteServiceTypeFile(this.props.serviceTypeId, fileName,
            {
              tenantId: this.props.user.queryParams.tenantId,
            }
          )
          .then((result) => {
            if (result.error) {
              toast.error('Something went wrong. Try again later.');
            } else {
              toast.success('File has been deleted.');
            }
          });
      }
      if (this.props.serviceRequestId !== undefined) {
        this.props
          .deleteServiceRequestFile(this.props.serviceRequestId, fileName,
            {
              tenantId: this.props.user.queryParams.tenantId,
            }
          )
          .then((result) => {
            if (result.error) {
              toast.error('Something went wrong. Try again later.');
            } else {
              toast.success('File has been deleted.');
            }
          });
      }
    }
  }

  render() {

    const {
      insuranceId
    } = this.props;

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));
    
    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

    return (
      <div >
        <div className="row">
          <div className="col-lg-5 col-md-5">
            {this.state.filesToShow &&
              this.state.filesToShow.map((file) => (
                <li className="list-group-item" key={file.fileName ? file.fileName : file.name}>
                  <span className="filename">{file.fileName ? file.fileName : file.name} </span>
                  {` `}
                  <a
                    className="action btn btn-xs btn-default pull-right"
                    onClick={() => this.deleteFile(file.id, file.fileName ? file.fileName : file.name)}
                  >
                    <i className="fa fa-trash" />
                  </a>
                </li>
              ))}
          </div>
          <div className="col-lg-1 col-md-1">
          </div>
          <div className="col-lg-5 col-md-5">
            <a 
              className="btn btn-default"
              onClick={this.showModal.bind(this)}
            >
              <i className="fa fa-upload" />
              <br />
              Choose files to Upload
            </a>
          </div>
        </div>

        <Modal show={this.state.showModal}>
          <Modal.Header>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-hidden="true"
              onClick={this.closeModal.bind(this)}
            >
              &times;
            </button>
            <h4 className="modal-title" id="addFilesModalLabel">
              Add Files
            </h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row client-files-upload">
              <div
                className={
                  this.state.files.length > 0
                    ? 'col-sm-12'
                    : 'col-sm-12'
                }
              >
                <Dropzone
                  accept={(insuranceId === undefined) ? acceptedFiles : ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"}
                  onDrop={this.onDrop.bind(this)}
                  onFileDialogCancel={this.onCancel.bind(this)}
                >
                  {({
                    getRootProps,
                    getInputProps,
                    isDragActive,
                  }) => {
                    return (
                      <div
                        {...getRootProps()}
                        className={classNames(
                          'dropzone dropzone-client-files',
                          { 'dropzone--isActive': isDragActive },
                        )}
                      >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p>Drop files here...</p>
                        ) : (
                          <span className="text-center">
                            <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                              <span className="font-lg">
                                Drop files{' '}
                                <span className="font-xs">
                                  to upload
                                </span>
                              </span>
                              <span>
                                &nbsp;&nbsp;
                                <h4 className="display-inline">
                                  {' '}
                                  (Or Click)
                                </h4>
                              </span>
                            </span>
                          </span>
                        )}
                      </div>
                    );
                  }}
                </Dropzone>
              </div>
              {this.state.files.length > 0 && (
                <div className="col-sm-12">
                  <h4>Files to be uploaded</h4>
                  <ul className="list-group files-upload-list">
                    {filesToUpload}
                  </ul>
                  {` `}
                  {this.state.files.length === 1 && (
                    <h6 className="txt-color-red">Only one file per request accepted.</h6>
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={this.closeModal.bind(this)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={this.state.files.length === 0}
              onClick={this.onStartUpload.bind(this)}
            >
              Upload Files
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    user: state.currentUser,
  }),
  (dispatch) => ({
    getUserFile: (userId, file) => dispatch(getUserFile(userId, file)),
    deleteServiceTypeFile: (serviceTypeId, fileName, params) => dispatch(deleteServiceTypeFile(serviceTypeId, fileName, params)),
    deleteServiceRequestFile: (serviceRequestId, fileName, params) => dispatch(deleteServiceRequestFile(serviceRequestId, fileName, params)),
  }),
)(FilesForm);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/components/FilesForm.js